import { Box, Flex } from '@chakra-ui/react'
import { CompensationFilter } from 'containers/jobs-board/components/CompensationFilter'
import { RoleTypeFilter } from 'containers/jobs-board/components/RoleTypeFilter'
import { LocationInput } from 'containers/jobs-board/components/LocationInput/LocationInput'
import { RelocationFilter } from 'containers/jobs-board/components/RelocationFilter'
import { RemoteFilter } from 'containers/jobs-board/components/RemoteFilter'
import { SearchInput } from 'containers/jobs-board/components/SearchInput'
import { SearchInputTagsForMobile } from 'containers/jobs-board/components/SearchInput/SearchInput'
import { CountryCodeToCountryName, Facet } from 'containers/jobs-board/components/options'

const Filters = ({
    facets,
    loading,
    countryCodeToCountryName,
}: {
    facets?: Facet[]
    loading: boolean
    countryCodeToCountryName: CountryCodeToCountryName
}) => {
    return (
        <>
            <Flex
                justifyContent={{ lg: 'center' }}
                alignItems={{ md: 'center' }}
                px={{ base: '12px', md: '50px' }}
            >
                <Box w="100%" maxWidth={{ lg: '886px' }}>
                    <SearchInput
                        loading={loading}
                        countryCodeToCountryName={countryCodeToCountryName}
                    />
                </Box>
            </Flex>

            <Flex
                mt="16px"
                sx={{
                    '::-webkit-scrollbar': {
                        display: 'none',
                        scrollbarWidth: 'none',
                    },
                }}
                overflowX="auto"
                px={{ base: '12px', md: '50px' }}
                justifyContent={{ lg: 'center' }}
                alignItems={{ md: 'center' }}
            >
                <Flex
                    gridGap="8px"
                    justifyContent={{ base: 'initial', lg: 'space-between' }}
                    w={{ base: 'unset', lg: '886px' }}
                >
                    <LocationInput
                        countryCodeToCountryName={countryCodeToCountryName}
                        facets={facets}
                    />
                    <CompensationFilter />
                    <RoleTypeFilter />
                    <RemoteFilter />
                    <RelocationFilter />
                </Flex>
            </Flex>
            <Box mx={{ base: '12px', md: '50px' }}>
                <SearchInputTagsForMobile
                    countryCodeToCountryName={countryCodeToCountryName}
                />
            </Box>
        </>
    )
}
export default Filters
